import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const GrillIcon = (props: IconWrapperProps) => (
  <IconWrapper width="48" height="48" viewBox="0 0 48 48" {...props}>
    <rect width="48" height="48" fill="#E9E9E6" rx="24" />
    <path
      fill="#747778"
      fillRule="evenodd"
      d="M13.758 12.429h18.923V18h-2V14.43H15.758v5.317h16.923v6.77H13.758V23.5h2v1.016h14.923v-2.77H13.758V12.43ZM34 16.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h1v-6h-1a1 1 0 0 1-1-1ZM17.936 28.851a1 1 0 0 0-1.872-.702l-3 8a1 1 0 1 0 1.872.702l3-8Zm15.168 4.498a2.66 2.66 0 1 1-1.773.944l-2.254-5.408a1 1 0 0 1 1.846-.77l2.18 5.234ZM9 20.5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H9Zm9.11-3.213a1 1 0 0 1 1-1h8.703a1 1 0 0 1 0 2H19.11a1 1 0 0 1-1-1Zm15.923 18.708a.66.66 0 1 1-1.319 0 .66.66 0 0 1 1.319 0Z"
      clipRule="evenodd"
    />
  </IconWrapper>
);

export default GrillIcon;
